import Component from './twitter_instantwin_message.vue'
export default Component
